import { motion } from "framer-motion";
import { POSTER } from "./data";

const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  show: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, delay: i * 0.12, ease: [0.16, 1, 0.3, 1] },
  }),
};

export const Manifesto = () => {
  return (
    <section
      data-testid="manifesto-section"
      className="relative py-28 sm:py-40 overflow-hidden"
    >
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <motion.div
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-100px" }}
          variants={fadeUp}
          className="lg:col-span-5 relative"
        >
          <div className="relative aspect-[1042/1509] rounded-2xl overflow-hidden border border-[#e3e2dc]">
            <img
              data-testid="manifesto-poster"
              src={POSTER}
              alt="Deen District Pre-Order Now poster — Deen Dunya District keffiyeh hoodie sets in black, cream and pink"
              className="w-full h-full object-cover"
            />
          </div>
        </motion.div>

        <div className="lg:col-span-7">
          <motion.p
            custom={0}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true }}
            variants={fadeUp}
            className="font-mono-d text-[11px] uppercase tracking-[0.3em] text-[#ff2a85] mb-7 flex items-center gap-3"
          >
            <span className="diamond" /> Deen District Presents · The Origin
          </motion.p>

          <motion.h2
            custom={1}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true }}
            variants={fadeUp}
            className="font-display font-extrabold uppercase leading-[0.95] text-4xl sm:text-5xl lg:text-6xl tracking-tight"
          >
            Every movement <br />
            has a <span className="text-pink">beginning.</span>
          </motion.h2>

          <motion.p
            custom={2}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true }}
            variants={fadeUp}
            className="mt-7 font-serif-accent text-2xl sm:text-3xl text-[#0a0a0b]"
          >
            Ours begins with faith.
          </motion.p>

          <motion.div
            custom={3}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true }}
            variants={fadeUp}
            className="mt-8 space-y-5 max-w-xl text-[#5f5e5a] text-base sm:text-lg leading-relaxed"
          >
            <p>
              Built on Deen. Raised by Culture. Worn with Purpose. This isn't
              just clothing — it's an identity, stitched for those who carry
              their faith louder than the noise.
            </p>
            <p className="text-[#0a0a0b]">
              The Origin Collection is our first mark on the world. A limited
              first drop for the unapologetic.
            </p>
          </motion.div>

          <motion.div
            custom={4}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true }}
            variants={fadeUp}
            className="mt-9 inline-flex items-center gap-4 border border-[#e3e2dc] rounded-full px-6 py-3"
          >
            <span className="font-mono-d text-[11px] uppercase tracking-[0.25em] text-[#0a0a0b]">
              Pre-Order Open
            </span>
            <span className="h-4 w-px bg-[#e3e2dc]" />
            <span className="font-mono-d text-[11px] uppercase tracking-[0.25em] text-[#ff2a85]">
              Limited First Drop
            </span>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
